const LOOPBACK_HOSTS = new Set(['localhost', '127.0.0.1']);

type LocationLike = Pick<Location, 'href' | 'hostname'>;

export function resolveRuntimeAppUrl(targetUrl: string, currentLocation: LocationLike = window.location): string {
  try {
    const resolvedUrl = new URL(targetUrl, currentLocation.href);

    if (!LOOPBACK_HOSTS.has(resolvedUrl.hostname) || !LOOPBACK_HOSTS.has(currentLocation.hostname)) {
      return resolvedUrl.toString();
    }

    resolvedUrl.hostname = currentLocation.hostname;
    return resolvedUrl.toString();
  } catch {
    return targetUrl;
  }
}

